import LazyImage from '@insided/shared/uikit/LazyImage'
import classnames from 'classnames'
import { ComponentChildren, FunctionalComponent } from 'preact'

export interface FeaturedCardProps {
  url: string
  title: string
  label?: string
  showLabel?: boolean
  titleSlot?: ComponentChildren
  children?: ComponentChildren
  featuredImage: string
  featuredImageAlt: string
}
const FeaturedCard: FunctionalComponent<FeaturedCardProps> = ({
  title,
  label,
  showLabel = true,
  featuredImage,
  featuredImageAlt,
  titleSlot,
  children
}) => (
  <div className='featured-topic__url card-widget-wrapper'>
    <div>
      {showLabel && label && (
        <span
          className={classnames(
            'topic__content-type-pill',
            'pill',
            'pill--uppercase',
            'pill--article',
            'qa-content-type-pill'
          )}
        >
          {label}
        </span>
      )}
      {featuredImage && (
        <figure>
          <LazyImage
            type='background'
            src={featuredImage}
            className='featured-topic__hero'
            alt={featuredImageAlt}
          />
        </figure>
      )}
    </div>

    <div className='featured-topic__title'>
      <h3
        className={classnames('featured-topic__heading', 'card-widget-title', {
          'featured-topic__heading--no-image': !featuredImage && label
        })}
      >
        {title}
        {titleSlot}
      </h3>
      {children}
    </div>
  </div>
)

export default FeaturedCard
